import { useState, useEffect } from 'react';

import * as api from '../../../api';

const CHECKING_IN_STATUSES = [
  api.Encounter.AppointmentStatus.Confirmed,
  api.Encounter.AppointmentStatus.Scheduled,
  api.Encounter.AppointmentStatus.Rescheduled,
];

const CHECKED_IN_STATUSES = [
  api.Encounter.AppointmentStatus.Arrived,
  api.Encounter.AppointmentStatus.CheckedIn,
];

const VALID_STATUSES = [...CHECKING_IN_STATUSES, ...CHECKED_IN_STATUSES];

export const useDigitalCheckIn = (
  status?: api.Encounter.AppointmentStatus | null,
) => {
  const [isCheckingIn, setIsCheckingIn] = useState(false);
  const [isValidStatus, setIsValidStatus] = useState(false);

  useEffect(() => {
    if (status === null) {
      setIsCheckingIn(true);
      setIsValidStatus(true);
      return;
    }
    if (status === undefined) {
      setIsCheckingIn(false);
      setIsValidStatus(false);
      return;
    }
    setIsCheckingIn(CHECKING_IN_STATUSES.includes(status));
    setIsValidStatus(VALID_STATUSES.includes(status));
  }, [status]);

  return { isCheckingIn, isValidStatus };
};
